import { privateRequest } from "../axios";

export interface ILeave {
  LeaveDate: string;
  StatusId: number;
  LeaveStatus: string;
}

export interface IUserLeave {
  UserId: number;
  UserName: string;
  EmployeeNo: string;
  Leaves: ILeave[];
}

const ENDPOINTS = {
  GET_LEAVES: "api/Leaves",
};

export const fetchLeaves = async (fromDate: string, toDate: string): Promise<IUserLeave[]> => {
  const response = await privateRequest.get(
    `${ENDPOINTS.GET_LEAVES}?FromDate=${fromDate}&ToDate=${toDate}`
  );
  return response.data.data;
};
